import { EffectComposer, Bloom, Vignette } from '@react-three/postprocessing';
import { useDebugStore } from '@/store/useDebugStore';
import { useWebGPUSupport } from '@/hooks/useWebGPUSupport';

/**
 * Postprocessing stack.
 *
 * NOTE: `@react-three/postprocessing` v3 does not yet fully support the
 * WebGPU backend. We disable effects automatically on WebGPU until the
 * upstream library stabilises.
 */
export function Effects() {
  const enabled = useDebugStore((s) => s.postprocessing);
  const useWebGPU = useWebGPUSupport();
  if (!enabled || useWebGPU) return null;
  return (
    <EffectComposer>
      <Bloom
        intensity={0.7}
        luminanceThreshold={0.55}
        luminanceSmoothing={0.4}
        mipmapBlur
      />
      <Vignette eskil={false} offset={0.18} darkness={0.5} />
    </EffectComposer>
  );
}
